import React, {useMemo} from "react";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {FixedSizeList} from "react-window";
import {CheckCircleIcon, CrossIcon} from "lucide-react";

const VirtualizedList = ({items, completedContents, onItemClick, extraData, currentContentIndex}) => {


    const sortedItems = useMemo(() => {
        return [...items].sort((a, b) => a.position - b.position);
    }, [items]);

    const handleItemClick = (item) => {
        onItemClick(item);
    };

    const renderRow = ({index, style}) => {
        const item = sortedItems[index];
        if (!item) return null;

        const isSelected = item.position === currentContentIndex;

        return (
            <ListItem
                style={{
                    ...style,
                    backgroundColor: isSelected ? "rgb(27,20,100)" : "transparent",
                    color:  isSelected ? "white" : "black",

                }}
                key={item.id || index}
                component="div"
                disablePadding
                onClick={() => handleItemClick(item)}
            >
                <ListItemButton>
                    <ListItemText primary={item.position + ". " + item.title}/>
                    {completedContents.includes(item.id) ? (
                        <CheckCircleIcon size={24}/>
                    ) : (
                        <CrossIcon size={24}/>
                    )}
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <div>
            <Box sx={{width: "95%", height: 450, maxWidth: 300}}>
                {items.length > 0 ? (
                    <FixedSizeList
                        height={465}
                        disableWidth={true}
                        itemSize={50}
                        itemCount={items.length}
                        overscanCount={5}
                        extraData={extraData}
                    >
                        {renderRow}
                    </FixedSizeList>
                ) : (
                    <p>Loading content...</p>
                )}
            </Box>
        </div>
    );
};

export default VirtualizedList;